import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { CustomerReportResponse } from '../../../interfaces/reports.interface';
import { apiRQ } from '../../api';
import { MONEY_COLLECTION_TRADER_TYPE } from '../../../interfaces/moneyCollection.interface';

interface Props {
  customerId: string;
  start: string;
  end: string;
  includeMoneyCollection: boolean;
  includeDeliveryNotes: boolean;
  traderType: MONEY_COLLECTION_TRADER_TYPE;
  orderBy?: string;
  order?: string;
}

const getCustomerReport = async (params: Props): Promise<CustomerReportResponse> => {
  // Keep only date from start/end dates
  const data = {
    ...params,
    start: params?.start?.split?.('T')?.[0] || undefined,
    end: params?.end?.split?.('T')?.[0] || undefined,
  };
  // @ts-expect-error remove `customerId` from query params since we have it in path params
  delete data?.customerId;

  const resp = await apiRQ.get<CustomerReportResponse>(`/reports/customers/${params.customerId}`, { params: data });

  return resp.data;
};

export const useCustomerMutateReport = () => {
  return useMutation<CustomerReportResponse, AxiosError, Props>(getCustomerReport, {
    mutationKey: [useCustomerMutateReport],
  });
};
